"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialTextArea = void 0;
const callable_1 = require("client/components/ui/callable");
const react_1 = require("react");
const React = require("react");
require("../text-field/text-field.less");
require("./text-area.less");
class MaterialTextArea extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleOnChange = (event) => {
            callable_1.callable(this.props.onChange)(event, event.target.value);
        };
    }
    render() {
        const { className = "", placeholder = "", value, missing, disabled, rows, required = false } = this.props;
        const isMissing = missing ? "material-text-field--missing" : "";
        return (React.createElement("div", { className: `material-text-area ${className} ${isMissing}` },
            React.createElement("textarea", { value: value, onChange: this.handleOnChange, placeholder: placeholder, required: required, disabled: disabled, rows: rows })));
    }
}
exports.MaterialTextArea = MaterialTextArea;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/text-area/text-area.tsx
// module id = 3017
// module chunks = 0